import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RestBuilder } from './helpers/rest.builder';
import { AccessibilityAuditToolNames } from '../../../shared/constants/audit-tool';
import { IScanSummaries, IPageError } from '../../../shared/interfaces/scan-summaries.interface';
import { ApiQueryOption } from '../../../shared/constants/api';

@Injectable({
  providedIn: 'root',
})
export class ScanSummariesService {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  public getSummariesForScan(workspaceId: string, digitalPropertyId: string, scanId: string): Observable<IScanSummaries> {
    const url: string = this.restBuilder
      .create()
      .workspaces(workspaceId)
      .digitalProperty(digitalPropertyId)
      .scan(scanId)
      .scanSummary()
      .getApiUrl();

    return this.httpClient.get<IScanSummaries>(url);
  }

  // GET /workspace/:workspaceId/:digitalPropertyId/scan/:scanId/scanSummary/previous
  public getPreviousSummariesForScan(workspaceId: string, digitalPropertyId: string, scanId: string): Observable<IScanSummaries> {
    const url: string = this.restBuilder
      .create()
      .workspaces(workspaceId)
      .digitalProperty(digitalPropertyId)
      .scan(scanId)
      .scanSummary()
      .previous()
      .getApiUrl();

    return this.httpClient.get<IScanSummaries>(url);
  }

  public getScanErrors(
    workspaceId: string,
    digitalPropertyId: string,
    scanId: string,
    toolName: AccessibilityAuditToolNames,
    limit: number,
    page: number,
  ): Observable<IPageError[]> {
    const url: string = this.restBuilder
      .create()
      .workspaces(workspaceId)
      .digitalProperty(digitalPropertyId)
      .scan(scanId)
      .scanSummary()
      .errors()
      .toolName(toolName)
      .getApiUrl();

    const params: HttpParams = new HttpParams({
      fromObject: {
        [ApiQueryOption.limit]: String(limit),
        [ApiQueryOption.page]: String(page),
      },
    });

    return this.httpClient.get<IPageError[]>(url, { params: params });
  }

  public getTotalScanErrors(
    workspaceId: string,
    digitalPropertyId: string,
    scanId: string,
    toolName: AccessibilityAuditToolNames,
  ): Observable<number> {
    const url: string = this.restBuilder
      .create()
      .workspaces(workspaceId)
      .digitalProperty(digitalPropertyId)
      .scan(scanId)
      .scanSummary()
      .errors()
      .toolName(toolName)
      .total()
      .getApiUrl();

    return this.httpClient.get<number>(url);
  }
}
